export { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
